import { bp } from "@fullcalendar/core/internal-common";

export const DeliveryPreparedness = {
    syphilisTestError: "VDRL Test is required atleast once during Pregnancy. Select the valid test result value.",
    syphilisTestDateError: "VDRL Test date cannot be kept empty. Enter a valid test date.",

    HIVTestError: "HIV Screening Test is required atleast once during Pregnancy. Select the valid test result value.",
    HIVTestDateError: "HIV Screening Test date cannot be kept empty. Enter a valid test date.",


    HBsAgTestError: "HBsAG cannot be kept empty. Select a valid option",
    HBsAgTestDateError: "HBsAG Test date cannot be kept empty. Enter a valid test date.",

    IntrapartumTdVaccinationError: "Intrapartum Td vaccination given cannot be blank. Select a option from the dropdown",
    IntrapartumTdVaccinationDateError: "TD date cannot be left empty. Select a valid TD Vaccination Date",

    ThyroidTestError: "Thyroid Test is required atleast once during Pregnancy. Select the valid test result value.",
    ThyroidTestDateError: "Thyroid Test date cannot be kept empty. Enter a valid test date.",

    ppTestError: "PP Test cannot be blank. Select a valid option.",
    ppTestDateError: "PP Test date cannot be left Blank. Select a valid Date.",
    ppRangeError: "PP test Diastolic must be between 30 and 500 mg/dl.",


    ogttTestError: "OGTT Test cannot be Blank. Select a valid option.",
    ogttTestDateError: "OGTT Test date cannot be left Blank. Select a valid Date.",
    ogttRangeError: "OGTT Test  must be in the range from 30 to 500mg/dl",

    bpSystolicError: "BP Systolic cannot be kept empty. Enter a valid BP Systolic value.",
    bpDiastolicError: "BP Diastolic cannot be kept empty. Enter a valid BP Diastolic value.",
    bpLessError:  "BP Systolic cannot be less than BP Diastolic.",
    bpMoreError:  "BP Diastolic cannot be more than BP Systolic.",
    bpSystolicRangeError: "BP Systolic must be between 40 and 400 mm.",
    bpDiastolicRangeError:"BP Diastolic must be between 30 and 300 mm.",



    hbError: "Hb cannot be kept empty. Select a valid HB value range.",

    bloodSugarTestError: "Blood Sugar Test cannot be kept empty. Select a valid option.",

    urineTestError: "Urine Test cannot be kept empty. Select a valid option.",
    urineTestDateError: "Test Date cannot be kept empty. Enter a valid test date.",

};
 
export const pregnancyClosure={
    success:"Pregnancy Closed Successfully"
}

export const error={
    errorMessage:"Something went wrong"
}

export const SpecialTests = {
    syphilisTestError: "VDRL Test is required atleast once during Pregnancy. Select the valid test result value.",
    syphilisTestDateError: "VDRL Test date cannot be kept empty. Enter a valid test date.",
 
    HIVTestError: "HIV Screening Test is required atleast once during Pregnancy. Select the valid test result value.",
    HIVTestDateError: "HIV Screening Test date cannot be kept empty. Enter a valid test date.",
 
    HBsAgTestError: "HBsAG Test cannot be kept empty. Select the valid test result value.",
    HBsAgTestDateError: "HBsAG Test date cannot be kept empty. Enter a valid test date.",
 
    rapidMalariaTestError: "Rapid Malaria Test cannot be kept empty. Select the valid test result value.",
    rapidMalariaTestDateError: "Rapid Malaria Test Date cannot be kept empty. Enter a valid test date.",

    ultraSoundTestDateError: "Test Date cannot be kept empty. Enter a valid test date.",
    ultraSountTestError:"Ultrasound Screening cannot be kept empty. Select a valid value.",
    ultraSoundDone: "This field cannot be kept blank. Select an applicable value.",

    ThyroidTestError:"Thyroid Test cannot be blank. Select a test result group from the dropdown",
    ThyroidTestDateError: "Thyroid Test date cannot be kept empty. Enter a valid test date.",

    TBScreeningTestDateError: "TB Screening Test date cannot be kept empty. Enter a valid test date.",
    TBScreeningTestError: "TB Screening Test is required atleast once during Pregnancy. Select the valid test result value.",
}
 
export const PEObstetricHistory = {
    HeightError:"PW Height cannot be kept empty. Enter a valid measured height.",
    WeightError: "PW Weight cannot be kept empty. Enter a valid measured weight.",
    WeightRangeError: "Weight should be within the range of 30kgs to 200 kgs",
    ObstreticHistoryError: "Obstetric history cannot be kept empty. Select valid options for Obstetric History."
}

export const TdInjection={
    TdDoseError: "Select Td Dose from Dropdown",
    TdDoseDateError: "Select Td Dose Date",

}

export const RoutineAncCheckup = {
    hbError: "Hb cannot be kept empty. Select a valid HB value range.",

    bpSystolicError: "BP Systolic cannot be kept empty. Enter a valid BP Systolic value.",
    bpDiastolicError: "BP Diastolic cannot be kept empty. Enter a valid BP Diastolic value.",
    bpLessError:  "BP Systolic cannot be less than BP Diastolic.",
    bpMoreError:  "BP Diastolic cannot be more than BP Systolic.",
    bpSystolicRangeError: "BP Systolic must be between 40 and 400 mm.",
    bpDiastolicRangeError:"BP Diastolic must be between 30 and 300 mm.",

    ppTestError: "PP Test cannot be blank. Select a valid option.",
    ppTestDateError: "PP Test date cannot be left Blank. Select a valid Date.",
    urineTestError: "Urine Test cannot be kept empty. Select a valid option.",
    urineTestDateError: "Test Date cannot be kept empty. Enter a valid test date.",

    bloodSugarTestError: "Blood Sugar Test cannot be kept empty. Select a valid option.",

    FoetalFormError: "Other Symptoms cannot be kept empty. Select a valid option.",
    FundalHeightError: "Fundal Height/ Size of the Uterus cannot be kept empty. Select a valid option.",
    SevereAnemiaError: "Severe Anaemic Treatment cannot be kept empty. Select valid option.",

    OtherSymptomsError: "Other High Risk Symptoms cannot be kept empty. Select a valid option",
    ppRangeError: "PP test Diastolic must be between 30 and 500 mg/dl.",

    ogttTestError: "OGTT Test cannot be Blank. Select a valid option.",
    ogttTestDateError: "OGTT Test date cannot be left Blank. Select a valid Date.",
    ogttRangeError: "OGTT Test  must be in the range from 30 to 500mg/dl",
}

export const AncServiceForm = {
    FolicAcidError: "Entered Number of Folic Acid tabs are invalid. Select a valid value.",
    IFATabsError: "Number of IFA tabs given cannot be more than 400.",
    CalciumVitTabsError: "Number of Calcium + Vit D3 tabs given cannot be more than 360.",
    TdDoseError: "Td dose date cannot be blank.",
    GET_API_ERROR_MESSAGE: (apiName: string) => `Error in retrieving data from the ${apiName} API`,
    LATEST_SERVICE_AVAILED_DATE: "latest service availed",
    CONSENT_CHANGES: 'consent language',
    CHILD_GENDER: 'child gender',
    REGISTRATION_FLOWS: 'registration flows'
}

export const UsgForm = {
    UltraSoundScreeningError: 'Select Ultra Sound Screening',
    UltraSoundScreeningDropDownError: "Select from Dropdown Options",
    SelectDateerror:"Select Date"
}

export const FacilityDetails = {
    facilityTypeError: "Facility Type cannot be blank.",
    facilityNameError: "Facility Name cannot be blank.",
    healthProviderName: "Health Provider Name cannot be blank.",
    visitTypeError: "Visit Type cannot be blank. Select a visit type from the dropdown",
    ancVisitDateError: "Select a date of ANC visit",
    visitDateError: "Visit Date cannot be blank.",
    VISIT_DATE_IN_FUTURE_ERROR: "Visit date cannot be selected as latest visit is after fourth ANC period end date.",
    VISIT_DATE_BEYOND_30_DAYS_ERROR: (isHrp: boolean) => `Visit date cannot be selected beyond ${isHrp ? 15 : 90} days after fourth ANC period end date.`
}

export const ANC_SUB_SERVICE = {
    ROUTINE_ANC: 'Routine ANC Checkups',
    PE_OBSTETRIC_HISTORY: 'PE & Obstetric History',
    ADDITIONAL_ANC_SERVICE: 'Additional ANC service',
    OBSETETRIC_HISTORY: 'Obstetric History',
}

export const ANC_COMMON_CONSTANTS = {
    VISIT_DATE_PERIOD: 89,
    ANC_ONE_END_DATE_PERIOD: 91,
    ANC_TWO_START_DATE_PERIOD: 92,
    ANC_TWO_END_DATE_PERIOD: 189,
    ANC_THREE_START_DATE_PERIOD: 190,
    ANC_THREE_END_DATE_PERIOD: 245,
    ANC_FOUR_START_DATE_PERIOD: 246,
    ANC_FOUR_END_DATE_PERIOD: 280,
}

export const ANC_ROUTES = {
    SPECIAL_TEST: '/beneficiaries/anc-service/special-test',
    USG: '/beneficiaries/anc-service/usg'
}

export const PREGNANCY_COMMON_CONSTANTS = {
    EARLY_PRIMIGRAVIDA: 'early_primigravida',
    ELDERLY_PRIMIGRAVIDA: 'elderly_primigravida',
    PRIMIGRAVIDA_AGE: 'primigravida_age',
}